import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService, IncomeTaxEntity,
  OmschrijvingEnBedrag,
  PGASpecifiekeZorgkosten
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-hulpmiddelen',
  templateUrl: './hulpmiddelen.component.html',
  styleUrls: ['./hulpmiddelen.component.scss'],
  imports: [
    SharedUiButtonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class HulpmiddelenComponent implements OnInit,OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public hulpmiddelen = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router:Router,private fb: FormBuilder) {
        this.hulpmiddelen = this.fb.group({
            pgaHulpmiddelen:
                this.fb.array<PGASpecifiekeZorgkosten>([])
        })
    }


    get pgaHulpmiddelen(): FormArray {
        return this.hulpmiddelen.get('pgaHulpmiddelen') as FormArray;
    }

    addRijHulpmiddelen(): void {
        this.pgaHulpmiddelen.push(this.createHulpmiddelenFormGroup()
        )
    }

    verwijderRijHulpmiddelen(index: number): void {
        this.pgaHulpmiddelen.removeAt(index);
        this.hulpmiddelen.updateValueAndValidity()
        this.hulpmiddelen.markAsDirty()
        this.saveForm()
    }



    createHulpmiddelenFormGroup(hulpmiddel?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: hulpmiddel ? hulpmiddel.omschrijving : undefined,
            bedrag: hulpmiddel ? hulpmiddel.bedrag : undefined
        } as OmschrijvingEnBedrag));
    }

    public ngOnInit(): void {
       this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.hulpmiddelen.dirty;
  }

  private updateForm(): void {
        const hulpmiddelenLijst = this.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten?.hulpmiddelen || [];
        const formArray = this.hulpmiddelen.get('pgaHulpmiddelen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > hulpmiddelenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < hulpmiddelenLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(hulpmiddelenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createHulpmiddelenFormGroup(hulpmiddelenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaSpecifiekeZorgkosten: {
                        ...this.aangifte.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten,
                        hulpmiddelen: this.hulpmiddelen.value.pgaHulpmiddelen
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
